<era-group-permissions-entity-list-ui [acl]="acl$ | async"></era-group-permissions-entity-list-ui>